import { GROUP_ID, RULES_TYPE } from '../common/constant'

export const convertDataCriteria = (data) => {
  const criteriaEvent = []
  const criteriaFinancial = []
  const criteriaScore = []

  data.forEach((item) => {
    if (item.groupId === GROUP_ID[RULES_TYPE.EVENT_RULES]) {
      criteriaEvent.push(item)
    }
    if (item.groupId === GROUP_ID[RULES_TYPE.FINANCIAL_RULES]) {
      criteriaFinancial.push(item)
    }
    if (item.groupId === GROUP_ID[RULES_TYPE.SCORE_RULES]) {
      criteriaScore.push(item)
    }
  })
  return {
    criteriaEvent,
    criteriaFinancial,
    criteriaScore,
  }
}
